<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col">
       <h1>Hunter</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      hunter: (state) => state.hunter.hunter
    })
  },
  async created() {
    await this.loadHunterData();
  },
  methods: {
    ...mapActions('hunter', ['getHunterDataAction']),
    async loadHunterData() {
      await this.getHunterDataAction();
    }
  },
};
</script>
